import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-postcodeareas-main",
    templateUrl: "./postcodeareas.main.component.html",
    standalone: false
})
export class PostcodeAreasMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
